import { productService } from "../service/productservice";

const categories = [
  "spongeproducts",
  "beautyproducts",
  "beveragesproducts",
  "cannedproducts",
  "ethnicproducts",
  "flourproducts",
  "fruitsproducts",
  "grainsproducts",
  "oilproducts",
  "pasteproducts",
  "seafoodsproducts",
  "vegetableproducts",
  "spicesproducts",
  "orangeproducts",
];

const fetchAllProducts = async () => {
  const allProducts = [];

  for (const category of categories) {
    try {
      const response = await productService.getProductsByCategory(category);
      console.log(response)

      if (response.success && Array.isArray(response.products)) {

        allProducts.push(...response.products);
        console.log(allProducts)
      } else {
        console.warn(
          `Skipping category "${category}" - Invalid response structure:`,
          response
        );
      }
    } catch (categoryError) {
      console.log(`Error fetching products for category "${category}":`, categoryError);
    }
  }

  return allProducts;
};

export const allProductsPromise = fetchAllProducts();
